import type { SyntheticEvent } from "react";
import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import type { RootState } from "@litres-core/store";
import { SpriteIcon } from "@litres-libs/sprite-icons";
import { Icon } from "@litres/ui-kit/icon";
import { OldButton, EColors, EVariants } from "@litres/ui-kit/old-button";
import { useTranslation } from "@litres-libs/i18n";

import styles from "./ConfirmPanel.module.scss";

interface IConfirmPanel {
  onApply: (e: SyntheticEvent) => void;
  onCancel: (e: SyntheticEvent) => void;
  onClose: (e: SyntheticEvent) => void;
}

export const ConfirmPanel = (props: IConfirmPanel): JSX.Element => {
  const { t } = useTranslation();
  const { onApply, onCancel, onClose } = props;
  const isPDA = useSelector((state: RootState) => state.browser.pda);

  return (
    <div
      className={classNames(styles.confirmPanel, {
        [styles["confirmPanel__mobile"]]: isPDA,
      })}
      data-testid="safemode__confirm-panel"
    >
      <div className={styles.confirmPanel__icon}>
        <Icon name="adultContentLogo" />
      </div>
      <div
        className={classNames(styles.confirmPanel__content, {
          [styles["confirmPanel__content__mobile"]]: isPDA,
        })}
      >
        <div className={styles.confirmPanel__wrapper}>
          <div
            className={classNames(styles.confirmPanel__text, {
              [styles["confirmPanel__text__mobile"]]: isPDA,
            })}
          >
            <span>
              {t(
                "Результаты содержат контент для взрослых. Скрывать его на сайте?"
              )}
            </span>
          </div>
        </div>
        <div className={styles.confirmPanel__buttons}>
          <OldButton
            width="auto"
            height="auto"
            verticalPadding="6px"
            fontSize="14px"
            style={{
              paddingLeft: "12px",
              paddingRight: "12px",
              textTransform: "none",
              fontWeight: "normal",
            }}
            variant={EVariants.primary}
            color={EColors.orange}
            className={styles.button_orange}
            onClick={onApply}
          >
            {t("Скрывать")}
          </OldButton>
          <OldButton
            width="auto"
            height="auto"
            verticalPadding="6px"
            fontSize="14px"
            style={{
              paddingLeft: "12px",
              paddingRight: "12px",
              textTransform: "none",
              fontWeight: "normal",
            }}
            variant={EVariants.primary}
            color={EColors.gray}
            onClick={onCancel}
          >
            {t("Показывать")}
          </OldButton>
        </div>
      </div>
      <button
        type="button"
        className={styles["confirmPanel__close-button"]}
        onClick={onClose}
        data-testid="safemode__close-button"
        aria-label={t("Закрыть")}
      >
        <SpriteIcon name="close" size={16} />
      </button>
    </div>
  );
};
